import { sdk } from '@/api'
import { TeamSchema, TeamInputSchema } from '@/generated/sdk'

export default {
  state: () => {
    return {
      teams: [] as TeamSchema[],
      allTeams: [] as TeamSchema[],
      team: {},
    }
  },

  getters: {
    teams(state) {
      return state.teams
    },
    allTeams(state) {
      return state.allTeams
    },
    team(state) {
      return state.team
    },
  },

  mutations: {
    teams(state, value) {
      state.teams = value
    },
    allTeams(state, value) {
      state.allTeams = value
    },
    team(state, value) {
      state.team = value
    },
    initTeam(state, organizationId: string) {
      state.team = { organization: { id: organizationId } }
    },
  },

  actions: {
    async getTeams({ commit }, { input, queryArgs = { } }) {
      const { organization } = await sdk().getTeamsFromOrganization({ input, queryArgs })
      commit('teams', organization[0].teams)
    },

    async deleteTeam({ dispatch }, id: string) {
      return (await sdk().deleteTeam({ input: id })).deleteTeam
    },

    async createTeam({ commit, state }, input = null): Promise<void> {
      input = input ?? { ...state.team }
      const { createTeam } = await sdk().createTeam({ input })
    },

    async updateTeam({ state }, input): Promise<void> {
      delete input.createdAt
      const { updateTeam } = await sdk().updateTeam({ input })
    },
  },
}
